module.exports = __webpack_public_path__ + "img/icon-Get-Gray.c7a7c90b.png";